export const currentBuildVersion = "002";
